<table>
  <thead style="background-color: #4CAF50">
  <th>Autor</th>
  </thead>
  <tr *ngFor="let author of authors" >
    <td style="padding:10px">{{author.authorName}}</td>
  </tr>
</table>
